import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';
import { SearchToneDto } from '../../../dto/searchtone/searchtonedto';

export interface SearchToneRequest extends APIRequest
{
    getSearchToneRequest(): SearchToneDto;
}

export class SearchToneRequestImpl extends APIRequestDtoImpl implements SearchToneRequest
{
    constructor(private searchToneData: SearchToneDto)
    {
        super();
    }

    getSearchToneRequest(): SearchToneDto
    {
        return this.searchToneData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/search/searchtone/searchtonerequest.tsx